/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Publication status.
 */
export enum PropertyPortalPublicationStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    ERROR = 'error',
    UNKNOWN = 'unknown',
    PAUSED = 'paused',
    UNPUBLISHED = 'unpublished',
}
